import { DimensionUnitEnum } from 'api';

export const formatDimensionUnit = (unit: DimensionUnitEnum) => {
  switch (unit) {
    case DimensionUnitEnum.m:
      return 'Meter';
    case DimensionUnitEnum.cm:
      return 'Centimeter';
    case DimensionUnitEnum.mm:
      return 'Millimeter';
    case DimensionUnitEnum.in:
      return 'Inch';
    default:
      return '';
  }
};
